<template>
    <module-card :nextDisabled="nextDisabled">
        <Carousel :length="strategies.length" @change="change">
            <template v-slot:default="slotProps">
                <div>
                    <v-img class="mx-auto" :max-width="200" :src="strategies[slotProps.index].img"></v-img>
                    <span class="text-h6">{{ strategies[slotProps.index].title }}</span>
                    <div v-html="strategies[slotProps.index].text"></div>
                </div>
            </template>
        </Carousel>
    </module-card>
</template>

<script>
    import { every } from 'lodash';

    export default {
        data() {
            return {
                strategies: [
                    {
                        id: 1,
                        img: require('@/assets/PGetsWokeAboutSaferSex/Strategies/strategies_letgo.png'),
                        title: 'Let go.',
                        text: `
                            <p><strong>A feeling is temporary:</strong> if you wait you might still feel it, but the intensity will go down and make the feeling easier to deal with.</p>
                            <p><strong>Count to 10:</strong> it’s just a way of saying wait a while so you’re not so overwhelmed.  You might need to count to 10 three or four times, but it really works.</p>  
                            <p><strong>Breathe Deep:</strong> When we get overwhelmed or worked up we sometimes hold our breath, or start taking shallow, short breaths without even knowing it. We can’t control our emotions if we can’t control our breathing! Here’s what you do: inhale through your nose until you feel your stomach fill up like a balloon, and then exhale through your mouth nice and slow.  It helps get a lot of oxygen into your blood and straight to your brain to help you think clearly, and is a great way to start letting go.</p>
                        `,
                        visited: false
                    },
                    {
                        id: 2,
                        img: require('@/assets/PGetsWokeAboutSaferSex/Strategies/strategies_talkAboutIt.png'),
                        title: 'Talk about it',
                        text: `
                            <p><strong>Talk about it with someone you trust --</strong> a friend you respect, a counselor, a teacher, a doctor, a caseworker, or a therapist.</p>
                        `,
                        visited: false
                    },
                    {
                        id: 3,
                        img: require('@/assets/PGetsWokeAboutSaferSex/Strategies/strategies_distractYourself.png'),
                        title: 'Distract Yourself',
                        text: `
                            <p>Do something to take your mind off the strong, overwhelming feelings.</p>
                            <p>Read a magazine, take a walk, exercise, listen to some music, write out your feelings in a journal, or watch your favorite show on TV.</p>  
                            <p>When you return to the issue you’ll be calmer and better equipped to make a decision.</p>
                        `,
                        visited: false
                    },
                    {
                        id: 4,
                        img: require('@/assets/PGetsWokeAboutSaferSex/Strategies/strategies_thinkPositively.png'),
                        title: 'Think Positively',
                        text: `
                            <p>Tell yourself how strong you are and how much you’ve survived.  This too shall pass.</p>
                        `,
                        visited: false
                    },
                    {
                        id: 5,
                        img: require('@/assets/PGetsWokeAboutSaferSex/Strategies/strategies_walkaway.png'),
                        title: 'Walk Away',
                        text: `
                            <p>This may be the most difficult strategy of all, but sometimes walking away is the best thing you can do.</p>
                            <p>Tell yourself: “Some people are just ignorant and don’t deserve my time or attention.” OR “If they go low, I go high.”</p>  
                            <p>There are some people you probably <span style="text-decoration:underline">shouldn’t</span> walk away from, like the police. Or maybe your teacher or the principal at school or your supervisor or boss at your job – these figures have the authority to affect your safety, standing at school, or work.  Think about whether or not walking away from them is the right thing to do.</p>
                        `,
                        visited: false
                    }
                ]
            };
        },
        methods: {
            change(index) {
                this.strategies[index].visited = true;
            },
            nextDisabled() {
                return !every(this.strategies, (s) => {
                    return s.visited;
                });
            }
        }
    };
</script>

<style scoped>
    .unselected {
        opacity: 0.5;
    }
</style>
